import React, { useEffect, useState } from "react";

const TxtReader = () => {
  const [text, setText] = useState("");

  useEffect(() => {
    fetch("/app-ads.txt")
      .then((res) => res.text())
      .then(setText)
      .catch((err) => console.error("Failed to load txt file", err));
  }, []);

  return (
    <div style={{ padding: "1rem" }}>
      <h2>Text File Content</h2>
      <pre style={{ whiteSpace: "pre-wrap" }}>{text}</pre>
    </div>
  );
};

export default TxtReader;
